import type { FaireProductEntity } from "../../entity_types/product";

export const p_td6sxyw8kb: FaireProductEntity = {
  token: "p_td6sxyw8kb",
  type: "product",
  name: "Striped Terry Tote Bag",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/8b6c84ceb31476f8dccdb4713b0ee0ee966a95212a8629eee4c913ed50fb4ff2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9478134fe2d2830b38f94882a2e9006ef1798dc2cfaac6554602ef2ca0da2fb.jpeg",
    "https://cdn.faire.com/fastly/e0dbaf6f9e6e69506135c002e002ccc07c3fcabb0e831b85329946ba2708900a.jpeg",
    "https://cdn.faire.com/fastly/7e2d0d17a462bb2eaece8ffd34920a63992f22d885765e815d1f9053e629ef6c.jpeg",
    "https://cdn.faire.com/fastly/2e48648a1bbbc0acfbb02aed5bca43e4511e2ba993d3a89f3ae2fc8a1b75e617.jpeg",
    "https://cdn.faire.com/fastly/5b1acf797dfb56bdb261d30280a435104979d4c8f4002717d4f2c9f75b83523e.jpeg",
    "https://cdn.faire.com/fastly/78a6d4222e749c6747663f94ec3325af8e2def0d3a0e5012546402037a2f3caa.jpeg",
    "https://cdn.faire.com/fastly/1e95104e544229abe38efcd8732d5e58e4f91c8747bac44ecdc6016fa1a30194.jpeg",
    "https://cdn.faire.com/fastly/0beaeaa5b82715a34584b9b3416194672cba68bc76375f6c082730b958846a8a.jpeg",
    "https://cdn.faire.com/fastly/10d6e765a6dc310d369dd694ac9656470635336baec13197d51348b45404d893.jpeg",
    "https://cdn.faire.com/fastly/11b10d44f55e82eb948c10f334142c6ae3df4c5648f06c782f01ededd6ad0247.jpeg",
    "https://cdn.faire.com/fastly/eac1a1725fd4add379ac9caa409018246006b49c0cd8437c7f83b40e487c2abf.jpeg",
    "https://cdn.faire.com/fastly/149658a7deeac450d38ccc360fb60a5e21e67bc3e74d285399a41ab8b27e99f0.jpeg",
    "https://cdn.faire.com/fastly/eaed40f0840a7e0ad89d7b822715c85504b3d5c3643a22fa0f38f89363233193.jpeg",
    "https://cdn.faire.com/fastly/fed55065363e76c4e08057a112f037f49760a09d087a41cb8a581aa2486303c5.jpeg",
    "https://cdn.faire.com/fastly/8e98d490c7b875de88c55c6b9e9f17c56a7bb9279aa7f76a0970a9784c036e9e.jpeg",
    "https://cdn.faire.com/fastly/f5dfb49e215d53661a27028d6625d9da5694441c102110dfde14c0f58d5d448c.jpeg",
    "https://cdn.faire.com/fastly/b1e5ee47bcc2ebaa9d8d3320579d93a4074ed3947f3cc57a460a920c2da11d4d.jpeg",
    "https://cdn.faire.com/fastly/b6cd6bde4006f45f9fb41a07f7f1e4112d5c78ef4e5f8466e943591849f3548e.jpeg",
    "https://cdn.faire.com/fastly/8c216d3add676e5684710d1bb8beca97add3d2e3d9b7ac64b2eb614827a71646.jpeg",
    "https://cdn.faire.com/fastly/b8f226004b2085bf860381a23a4c4087e896f7bdc6601f8c6ae8080583828668.jpeg",
    "https://cdn.faire.com/fastly/82e808f633665fcbe582f36a17ad3fc09a7232bd071effce87475ab1a4bf5979.jpeg",
    "https://cdn.faire.com/fastly/6c889fc9389d46debc0174bee351da56a17a9bbd2903cafcbcbc0a70fa6eda49.jpeg",
    "https://cdn.faire.com/fastly/2df9a505e9af19ce7ac138c5de1d33b3a6b62fb6af05bde8cb6e9ed90bc32df8.jpeg",
    "https://cdn.faire.com/fastly/e414aeed52914fa15238b6521c7a13d4f21860f8de9cb851ba78579dae63280f.jpeg",
    "https://cdn.faire.com/fastly/71aaf43e4f8d5bb1155a0f6330dfddc1360569b094e111c79e630ca23e3e8742.jpeg",
    "https://cdn.faire.com/fastly/d80137ac3258008ff48dda77809cfae3909c367ee1f8fb342b8f547a164eece3.jpeg",
    "https://cdn.faire.com/fastly/cfef2f8d4e545d8402df8e68d379e26ed244ce5e215d918c8d3f7d06fefe86ff.jpeg",
    "https://cdn.faire.com/fastly/30b1b90333dc2312a265ae9816ac9dfe04758b533489945f56947dca9c5cfe42.jpeg",
    "https://cdn.faire.com/fastly/a77cc07b9dfaddb4911ba6a452c24c0dafc7f81b61e6a674cde14f3c8244abea.jpeg",
    "https://cdn.faire.com/fastly/82fb72d42d336f7383060a186f530c7a2ea02a61a4e1aa6dc447f9f1a279f02e.jpeg",
    "https://cdn.faire.com/fastly/0c0579cf2829f056c7ee33e9b0f442671efb19931f7efee1994b711a09fa5539.jpeg",
    "https://cdn.faire.com/fastly/263846197698ae4832b4c1b6040760a408f5af81aef4294082cdf988006b35da.jpeg",
    "https://cdn.faire.com/fastly/8c28a297bf0934d948e279ca1f505fc1f979d37a1ae74d292f250e8267b8a2cf.jpeg",
    "https://cdn.faire.com/fastly/a1c58b2564e43f718b97c449d2146a6c64bdaa9b2b1d166818fc392209e6a579.jpeg",
    "https://cdn.faire.com/fastly/ca42249a00b52eb994cb5fa584cb688b9291b993b54c6001a5247019f4b257dd.jpeg",
    "https://cdn.faire.com/fastly/b9262105d13f787359c75237418c7d00d3caa88dd9721016c4da0cb4aec1f225.jpeg",
    "https://cdn.faire.com/fastly/bce71e35f6763e08c58263ca9673f00298eccfe42c039afa3e9e3ef250321029.jpeg",
    "https://cdn.faire.com/fastly/156c960f42a11248ed51eef1b60d90c44c844818c2dc84747ec7fde990598770.jpeg",
    "https://cdn.faire.com/fastly/b5f97de653904e8ad059c03f921a5bb3f26972741bf2368c6a18761323b7dedb.jpeg",
    "https://cdn.faire.com/fastly/f161c7f3c089b8ddf03fef1e299f1b0ef0365db4c103a181247406c8d1c20bd9.jpeg",
    "https://cdn.faire.com/fastly/23798c92b70cd81e2fde5bfecb79b7bc9a8cae774504a1c9fae36c9cbcac060d.jpeg",
  ],
  priceDollars: 11.28,
  description:
    'Size : 22.5" X 13.5" X 9.5"\r\nInner Pocket\r\nMagnetic Snap Closure\r\nMaterial : 80% Polyester, 20% Polyamide\r\nClassic striped tote bag designed for everyday summer use. Ideal for beach days, shopping, travel, or casual outings, this roomy carryall offers ample space for essentials while delivering a clean, timeless look that pairs easily with warm weather outfits and seasonal activities.\n',
  tags: [],
  msrpDollars: 22.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:07.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
